// import { IBritaxProductRegistrationProps } from '../britax-product-registration.props.autogenerated';
// import { IBritaxProductRegistrationData } from '../britax-product-registration.data';

// export interface IBritaxProductRegistrationExtendedProps extends IBritaxProductRegistrationProps<IBritaxProductRegistrationData>;

export enum InputID {
    firstName = 'firstName',
    lastName = 'lastName',
    email = 'email',
    contactNumber = 'contactNumber',
    productType = 'productType',
    productName = 'productName',
    storeName = 'storeName',
    itemNumber = 'itemNumber',
    dateOfPurchase = 'dateOfPurchase',
    dateOfManufacture = 'dateOfManufacture',
    serialNumber = 'serialNumber',
    reorderCode = 'reorderCode'
}
export const initialErrorState = {
    [InputID.firstName]: '',
    [InputID.lastName]: '',
    [InputID.email]: '',
    [InputID.contactNumber]: '',
    [InputID.productType]: '',
    [InputID.productName]: '',
    [InputID.storeName]: '',
    [InputID.dateOfPurchase]: '',
    [InputID.dateOfManufacture]: '',
    [InputID.itemNumber]: '',
    [InputID.serialNumber]: '',
    [InputID.reorderCode]: ''
};

export interface productRegistrationState {
    [InputID.firstName]: string;
    [InputID.lastName]: string;
    [InputID.email]: string;
    [InputID.contactNumber]: string;
    [InputID.productType]: string;
    [InputID.productName]: string;
    [InputID.dateOfPurchase]: string | undefined;
    [InputID.dateOfManufacture]: Date | string | undefined;
    [InputID.storeName]: string;
    [InputID.itemNumber]: string;
    [InputID.serialNumber]: string;
    [InputID.reorderCode]: string;
}

export interface IProductType {
    id: number;
    name: string;
    role: string;
    value: string;
}
